import { render, staticRenderFns } from "./TaskDownSelector.vue?vue&type=template&id=2a6bae9b&scoped=true&"
import script from "./TaskDownSelector.vue?vue&type=script&lang=js&"
export * from "./TaskDownSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaskDownSelector.vue?vue&type=style&index=0&id=2a6bae9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6bae9b",
  null
  
)

export default component.exports